module.exports = __webpack_public_path__ + "static/service-c377107b92c7124409ba3d29061ffd39.jpg";